import React, { useEffect, useRef, useState } from "react";
import LoaderForSearch from "../Components/Common/LoaderForSearch";

function SearchDropdown({
  value,
  placeholder,
  showDropdown,
  setShowDropdown,
  data,
  loading,
  error,
  onInputChange,
  onSelect,
  disabled
}) {
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const inputRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    if (showDropdown) {
      setHighlightIndex(0);
    } else {
      setHighlightIndex(-1);
    }
  }, [showDropdown]);

  const handleKeyDown = (e) => {
      if (e.key === "Tab") {
    setShowDropdown(false);
    return; // allow browser to move focus
  }
    if (!showDropdown) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();

        setHighlightIndex(prev =>
          Math.min(prev + 1, data.length - 1)
        );

        break;

      case "ArrowUp":
        e.preventDefault();

        setHighlightIndex(prev =>
          Math.max(prev - 1, 0)
        );

        break;

      case "Enter":
        e.preventDefault();

        if (highlightIndex >= 0) {
          onSelect(data[highlightIndex]);
          setShowDropdown(false);
        }

        break;

      case "Escape":
        setShowDropdown(false);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
  if (
    highlightIndex >= 0 &&
    itemRefs.current[highlightIndex]
  ) {
    itemRefs.current[highlightIndex].scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }
}, [highlightIndex]);


  return (
    <div className="rm-custom-dropdown mapping-dropdown">
      <input
        ref={inputRef}
        type="text"
        className="input-st"
        placeholder={placeholder}
        autoComplete="off"
        value={value}
        onChange={onInputChange}
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />

      <button
        type="button"
        className="rm-dropdown-btn"
        onClick={() => setShowDropdown(!showDropdown)}
        disabled={disabled}
         tabIndex={-1}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setShowDropdown(prev => !prev);
          }
        }}
      >
        <span className="icon-right-arrow-triangle"></span>
      </button>

      {showDropdown && (
        <ul className="rm-mapping-ap border-0">

          {data?.map((item, index) => (
            <li
              key={index}
              ref={(el) => (itemRefs.current[index] = el)}
              className={`rm-maping-item-wrapper ${
                highlightIndex === index ? "active-item" : ""
              }`}
              onMouseEnter={() => setHighlightIndex(index)}
              onClick={() => onSelect(item)}
            >
              <div>{item?.clientName || item?.dealerName}</div>
              <div>{item?.clientCode || item?.dealerCode}</div>
            </li>
          ))}

          {loading && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}

          {error && !loading && (
            <li
              className="rm-maping-item-wrapper"
              style={{
                borderBottom: "none",
                fontSize: "12px",
              }}
            >
              {error}
            </li>
          )}

        </ul>
      )}
    </div>
  );
}

export default SearchDropdown;